import * as React from "react";
import { Controller } from "react-hook-form";
import { MuiColorInput } from "mui-color-input";

const DEFAULT_COLOR = "#DDDDDD";
const COLOR_PICKER_Z_INDEX = 2147483647;

const isValidHexColor = (value: any) => {
  return typeof value === "string" && /^#[0-9A-Fa-f]{6}$/.test(value);
};

export const InputColorField = ({
  name,
  label,
  control,
  required = false,
}: any) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={{
        required: required ? `${label} is required` : false,
      }}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const safeValue = isValidHexColor(value) ? value : DEFAULT_COLOR;

        return (
          <MuiColorInput
            size="small"
            variant="outlined"
            fullWidth
            label={label}
            required={required}
            format="hex"
            helperText={error ? error.message : null}
            error={!!error}
            value={safeValue}
            onChange={(nextColor) => {
              onChange(isValidHexColor(nextColor) ? nextColor : DEFAULT_COLOR);
            }}
            PopoverProps={{
              sx: {
                zIndex: COLOR_PICKER_Z_INDEX,
              },
              PaperProps: {
                sx: {
                  zIndex: COLOR_PICKER_Z_INDEX,
                },
              },
            }}
            sx={{
              "& .MuiInputBase-root": {
                minHeight: 40,
              },
            }}
          />
        );
      }}
    />
  );
};

export default InputColorField;